export default __webpack_public_path__ + "static/media/16.9876ba93.png";